export default class BlockActivities {
	static init() {

		let blocks = document.querySelectorAll('.block-activities');

		blocks.forEach( (block) => {

			const links = block.querySelectorAll('.title');
			const images = block.querySelectorAll('.images .inner img');

			links.forEach( (link, i) => {
				link.addEventListener('mouseenter', () => {
					images.forEach( (img) => {
						img.classList.remove('reveal');
					});
					images[i].classList.add('reveal');
				});
			});

		});
	}

}
